import { IconProps, IconSize } from "../theme";

const BubbleChevronDown: React.FC<IconProps> = ({ size = IconSize.S }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5.29289 5.29289C5.68342 5.68342 6.31658 5.68342 6.70711 5.29289L11 1"
        stroke="#302B5D"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BubbleChevronDown;
